// Iteration 192 -- Match Day Templates
import { z } from "zod";

const hhmm = z.string().regex(/^([01]\d|2[0-3]):[0-5]\d$/, "Expected HH:mm");
const dateOnly = z.string().regex(/^\d{4}-\d{2}-\d{2}$/, "Expected YYYY-MM-DD");

const templateSlotInputSchema = z.object({
  court_id: z.string().min(1).optional().nullable(),
  court_name: z.string().min(1).max(200).optional().nullable(),
  slot_starts_at_local: hhmm,
  first_half_mins: z.number().int().positive().max(240),
  break_mins: z.number().int().min(0).max(120),
  second_half_mins: z.number().int().positive().max(240),
  sport_id: z.string().min(1).optional().nullable(),
  age_group: z.string().max(80).optional().nullable(),
  label: z.string().max(200).optional().nullable(),
  sort_order: z.number().int().optional(),
});

export const createMatchDayTemplateSchema = z
  .object({
    name: z.string().min(1).max(200),
    slots: z.array(templateSlotInputSchema).min(1).max(100),
  })
  .strict();

export const updateMatchDayTemplateSchema = z
  .object({
    name: z.string().min(1).max(200).optional(),
    slots: z.array(templateSlotInputSchema).min(1).max(100).optional(),
  })
  .strict();

export const saveAsMatchDayTemplateSchema = z
  .object({
    name: z.string().min(1).max(200),
    overwrite: z.boolean().optional().default(false),
  })
  .strict();

export const applyMatchDayTemplateSchema = z
  .object({
    template_id: z.string().min(1),
    date: dateOnly,
  })
  .strict();

export type MatchDayTemplateSlotInput = z.infer<typeof templateSlotInputSchema>;
export type CreateMatchDayTemplateInput = z.infer<typeof createMatchDayTemplateSchema>;
export type UpdateMatchDayTemplateInput = z.infer<typeof updateMatchDayTemplateSchema>;
export type SaveAsMatchDayTemplateInput = z.infer<typeof saveAsMatchDayTemplateSchema>;
export type ApplyMatchDayTemplateInput = z.infer<typeof applyMatchDayTemplateSchema>;
